"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GridFilter = void 0;
var _jsxRuntime = require("react/jsx-runtime");
const GridFilter = () => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      transform: "translate(0.707 0.707)",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("line", {
        x1: "9.897",
        transform: "translate(0)",
        strokeDasharray: "26"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("line", {
        x1: "7.897",
        transform: "translate(1 3.703)"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("line", {
        x1: "2",
        transform: "translate(3.933 7.405)"
      })]
    })
  });
};
exports.GridFilter = GridFilter;